const translation = {
  MENU_TITLE: 'Meu Painel',
  GENERAL_ERROR: 'Ocorreu um erro',
  TRY_AGAIN: 'Tente novamente',
  SEARCH_LABEL: 'O que você está procurando no seu painel?',
  INTERNET_CONNECTION_ERROR: 'Ocorreu um erro de conexão',
  RELOAD_PAGE: 'Recarregue a página',
};

export default translation;
